var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/service/loading",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5 L6,6 L2,6 L2,2 L3,2 L3,3.84245 C4.75156704,1.7381869 7.63358027,0.95650859 10.2083493,1.88735477 C12.7831184,2.81820095 14.4989889,5.26213418 14.5,8 L13.5,8 C13.5006387,5.56524295 11.9000215,3.41995994 9.56590272,2.72718891 C7.23178391,2.03441787 4.71998669,2.95912823 3.39225,5 L6,5 Z M10,11 L10,10 L14,10 L14,14 L13,14 L13,12.15755 C11.248433,14.2618131 8.36641973,15.0434914 5.79165068,14.1126452 C3.21688163,13.181799 1.50101112,10.7378658 1.5,8 L2.5,8 C2.49936129,10.4347571 4.09997847,12.5800401 6.43409728,13.2728111 C8.76821609,13.9655821 11.2800133,13.0408718 12.60775,11 L10,11 Z",
    id: "path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.0911626cea4431fc3799fe57fbbd983a.svg";
export { ForwardRef as ReactComponent };